import React, { Component } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, BarElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend);

export const options = {
  animation: false,
  responsive: true,
  plugins: {
    legend: {
      display: true
    },
    showAllTooltips: true,
    title: {
      display: true,
      text: '時間（分）',
      position: 'bottom',
      font: { weight: 'normal' }
    },
    tooltip: {
      callbacks: {
        title: (context) => context[0].label + '分'
      }
    }
  },
  scales: {
    y: {
      type: 'linear',
      display: true,
      position: 'right',
      grid: {
        drawOnChartArea: false
      },
      title: {
        display: true,
        text: '視聴維持率（%）'
      },
      min: 0,
      max: 100
    },
    y2: {
      type: 'linear',
      display: true,
      position: 'left',
      grid: {
        drawOnChartArea: false
      },
      title: {
        display: true,
        text: '購入数'
      },
      min: 0,
      ticks: {
        stepSize: 1
      }
    }
  }
};

export default class LiveReportGraph1 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <Bar options={options} data={this.props.data} />;
  }
}
